import { createMuiTheme } from '@material-ui/core/styles'

import blue from '@material-ui/core/colors/blue'
import orange from '@material-ui/core/colors/orange'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: blue[700],
      contrastText: '#fff'
    },
    secondary: {
      main: orange[700],
      contrastText: '#fff'
    }
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        fontSize: 14
      },
      label: {
        fontSize: 15
      }
    },
    MuiListItemIcon: {
      root: {
        marginRight: 0
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
        height: 16
      }
    }
  }
})

export default theme



// WEBPACK FOOTER //
// ./src/theme.js